import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

export const ARTICLE_CARDS: ArticleCardDataProps[] = [
  {
    heading: 'footer_press_section_right_1',
    buttonProps: {
      ariaLabel: 'press_read_article',
      external: true,
      color: 'dark',
      href: 'https://www.forbes.com/sites/davidphelan/2025/08/12/oura-reveals-cutting-edge-new-health-features-for-oura-ring/',
      rel: 'noopener noreferrer',
      siteName: 'Forbes',
      target: '_blank',
    },
  },
  {
    heading: 'footer_press_section_right_2',
    buttonProps: {
      ariaLabel: 'press_read_article',
      external: true,
      color: 'dark',
      href: 'https://www.oprahdaily.com/life/health/a65657856/oura-ring-perimenopause-pregnancy/',
      rel: 'noopener noreferrer',
      siteName: 'Oprah Daily',
      target: '_blank',
    },
  },
  {
    heading: 'footer_press_section_right_3',
    buttonProps: {
      ariaLabel: 'press_read_article',
      external: true,
      color: 'dark',
      href: 'https://time.com/collections/time100-companies-2025/7289650/oura/',
      rel: 'noopener noreferrer',
      siteName: 'TIME',
      target: '_blank',
    },
  },
];

export const ARTICLE_IMAGE: ArticleImageProps = {
  alt: 'press_section_primary_image_alt_ai',
  buttonProps: {
    external: true,
    href: 'https://www.fastcompany.com/91412624/oura-ring-ceramic-finishes',
    label: 'read_more',
    rel: 'noopener noreferrer',
    siteName: 'Fast Company',
    target: '_blank',
    variant: 'secondary-light',
  },
  heading: 'footer_press_section_hero',
  mobileSrc:
    'homepage/press-hero-ai.jpg?fp-y=0.60&fp-x=0.45&fp-z=1.1&fit=crop&crop=focalpoint',
  src: 'homepage/press-hero-ai.jpg?fp-x=0.40&fp-z=1.25&fit=crop&crop=focalpoint',
};
